export default "__VITE_PUBLIC_ASSET__a8d5b182__"